"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _excluded = ["schemaType", "propsWithKeys"];
function _default(_ref) {
  var _data$settings, _data$settings$basic_;
  var data = _ref.data,
    _ref$properties = _ref.properties,
    properties = _ref$properties === void 0 ? {} : _ref$properties;
  var languages = ((_data$settings = data.settings) === null || _data$settings === void 0 ? void 0 : (_data$settings$basic_ = _data$settings.basic_settings) === null || _data$settings$basic_ === void 0 ? void 0 : _data$settings$basic_.languages) || ["lang_1"];
  function getPropertiesByLanguages() {
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _p$schemaType = p.schemaType,
      schemaType = _p$schemaType === void 0 ? "String" : _p$schemaType,
      _p$propsWithKeys = p.propsWithKeys,
      propsWithKeys = _p$propsWithKeys === void 0 ? {} : _p$propsWithKeys,
      props = (0, _objectWithoutProperties2["default"])(p, _excluded);
    return languages.reduce(function (o, value) {
      o[value] = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
        schemaType: schemaType
      }, props), propsWithKeys[value] ? propsWithKeys[value] : {});
      return o;
    }, {});
  }
  function getLanguageObject() {
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
      schemaType: "Object",
      properties: getPropertiesByLanguages(p)
    };
  }
  var textAreaProps = {
    multiline: true,
    rows: 4,
    minRows: 4,
    maxRows: 20
  };
  return {
    schemaType: "Object",
    label: "Editor",
    properties: (0, _objectSpread2["default"])({
      settings: {
        schemaType: "Object",
        properties: {
          basic_settings: {
            schemaType: "Object",
            properties: {
              name: getLanguageObject(),
              description: getLanguageObject((0, _objectSpread2["default"])({}, textAreaProps)),
              languages: {
                schemaType: "Array",
                add: function () {
                  var _add = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(_ref2) {
                    var schemaFormContext, props, setValue, _props$value, value, key, newSchema;
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
                      while (1) switch (_context.prev = _context.next) {
                        case 0:
                          schemaFormContext = _ref2.schemaFormContext, props = _ref2.props;
                          setValue = props.setValue, _props$value = props.value, value = _props$value === void 0 ? [] : _props$value;
                          key = "lang_" + (value.length + 1);
                          value.push(key);
                          _context.next = 6;
                          return setValue(value, true);
                        case 6:
                          newSchema = schemaFormContext.props.additionalProperties.generateSchema({
                            schemaFormContext: schemaFormContext
                          });
                          _context.next = 9;
                          return schemaFormContext.setSchema(newSchema);
                        case 9:
                        case "end":
                          return _context.stop();
                      }
                    }, _callee);
                  }));
                  function add(_x) {
                    return _add.apply(this, arguments);
                  }
                  return add;
                }(),
                items: {
                  schemaType: "String",
                  label: "Language code",
                  disabled: true,
                  enableDelete: function enableDelete(_ref3) {
                    var props = _ref3.props;
                    return props.parentValue && props.parentValue.length ? props.propertyKey && props.propertyKey === props.parentValue.length - 1 : false;
                  },
                  onDelete: function () {
                    var _onDelete = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(_ref4) {
                      var schemaFormContext, props, setSchema, newSchema;
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
                        while (1) switch (_context2.prev = _context2.next) {
                          case 0:
                            schemaFormContext = _ref4.schemaFormContext;
                            props = schemaFormContext.props, setSchema = schemaFormContext.setSchema;
                            newSchema = props.additionalProperties.generateSchema({
                              schemaFormContext: schemaFormContext
                            });
                            _context2.next = 5;
                            return setSchema(newSchema);
                          case 5:
                          case "end":
                            return _context2.stop();
                        }
                      }, _callee2);
                    }));
                    function onDelete(_x2) {
                      return _onDelete.apply(this, arguments);
                    }
                    return onDelete;
                  }(),
                  onChange: function () {
                    var _onChange = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3(_ref5) {
                      var schemaFormContext, props, setSchema, newSchema;
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
                        while (1) switch (_context3.prev = _context3.next) {
                          case 0:
                            schemaFormContext = _ref5.schemaFormContext;
                            props = schemaFormContext.props, setSchema = schemaFormContext.setSchema;
                            newSchema = props.additionalProperties.generateSchema({
                              schemaFormContext: schemaFormContext
                            });
                            _context3.next = 5;
                            return setSchema(newSchema);
                          case 5:
                          case "end":
                            return _context3.stop();
                        }
                      }, _callee3);
                    }));
                    function onChange(_x3) {
                      return _onChange.apply(this, arguments);
                    }
                    return onChange;
                  }()
                }
              },
              menu: {
                schemaType: "Array",
                add: function () {
                  var _add2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee4(_ref6) {
                    var props, setValue, _props$value2, value;
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee4$(_context4) {
                      while (1) switch (_context4.prev = _context4.next) {
                        case 0:
                          props = _ref6.props;
                          setValue = props.setValue, _props$value2 = props.value, value = _props$value2 === void 0 ? [] : _props$value2;
                          value.push({
                            name: {},
                            icon: "",
                            href: "/",
                            target: ""
                          });
                          _context4.next = 5;
                          return setValue(value, true);
                        case 5:
                        case "end":
                          return _context4.stop();
                      }
                    }, _callee4);
                  }));
                  function add(_x4) {
                    return _add2.apply(this, arguments);
                  }
                  return add;
                }(),
                items: {
                  schemaType: "Object",
                  enableDelete: true,
                  properties: {
                    name: getLanguageObject(),
                    icon: {
                      schemaType: "String"
                    },
                    href: {
                      schemaType: "String"
                    },
                    target: {
                      schemaType: "String"
                    }
                  }
                }
              },
              footerMenu: {
                schemaType: "Array",
                add: function () {
                  var _add3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee5(_ref7) {
                    var props, setValue, _props$value3, value;
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee5$(_context5) {
                      while (1) switch (_context5.prev = _context5.next) {
                        case 0:
                          props = _ref7.props;
                          setValue = props.setValue, _props$value3 = props.value, value = _props$value3 === void 0 ? [] : _props$value3;
                          value.push({
                            name: {},
                            icon: "",
                            href: "/",
                            target: ""
                          });
                          _context5.next = 5;
                          return setValue(value, true);
                        case 5:
                        case "end":
                          return _context5.stop();
                      }
                    }, _callee5);
                  }));
                  function add(_x5) {
                    return _add3.apply(this, arguments);
                  }
                  return add;
                }(),
                items: {
                  schemaType: "Object",
                  enableDelete: true,
                  properties: {
                    name: getLanguageObject(),
                    icon: {
                      schemaType: "String"
                    },
                    href: {
                      schemaType: "String"
                    },
                    target: {
                      schemaType: "String"
                    }
                  }
                }
              }
            }
          },
          context: {
            schemaType: "Object",
            properties: {
              menus: {
                schemaType: "Object",
                properties: {}
              },
              messages: {
                schemaType: "Object",
                properties: {}
              },
              labels: {
                schemaType: "Object",
                properties: {}
              }
            }
          }
        }
      },
      compositions: {
        schemaType: "Array",
        add: function () {
          var _add4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee6(_ref8) {
            var props, setValue, _props$value4, value;
            return (0, _regeneratorRuntime2["default"])().wrap(function _callee6$(_context6) {
              while (1) switch (_context6.prev = _context6.next) {
                case 0:
                  props = _ref8.props;
                  setValue = props.setValue, _props$value4 = props.value, value = _props$value4 === void 0 ? [] : _props$value4;
                  value.push({});
                  _context6.next = 5;
                  return setValue(value, true);
                case 5:
                case "end":
                  return _context6.stop();
              }
            }, _callee6);
          }));
          function add(_x6) {
            return _add4.apply(this, arguments);
          }
          return add;
        }(),
        items: {
          schemaType: "Object",
          properties: {
            animation: {
              schemaType: "Array",
              add: function () {
                var _add5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee7(_ref9) {
                  var props, setValue, _props$value5, value;
                  return (0, _regeneratorRuntime2["default"])().wrap(function _callee7$(_context7) {
                    while (1) switch (_context7.prev = _context7.next) {
                      case 0:
                        props = _ref9.props;
                        setValue = props.setValue, _props$value5 = props.value, value = _props$value5 === void 0 ? [] : _props$value5;
                        value.push("");
                        _context7.next = 5;
                        return setValue(value, true);
                      case 5:
                      case "end":
                        return _context7.stop();
                    }
                  }, _callee7);
                }));
                function add(_x7) {
                  return _add5.apply(this, arguments);
                }
                return add;
              }(),
              items: {
                schemaType: "String",
                enableDelete: true
              }
            }
          }
        }
      }
    }, properties)
  };
}